
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/BundleProduct",
      function () {
        return require("private-next-pages/BundleProduct.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/BundleProduct"])
      });
    }
  